<nav class="navbar navbar-expand-lg d-none d-lg-flex" role="navigation" aria-label="Main navigation">
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
  >
    <span class="accessibility-only" id="homeLink">Go To Home Page</span>
    <img alt="" class="h-100" aria-labelledby="homeLink" [src]="'logos/logowhite.png' | contentAssetImage" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    [attr.aria-expanded]="!isCollapsed"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse flex-grow-1" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav" #greedyNav role="menubar">
        <li class="nav-item active" role="none">
          <a
            class="nav-link text-white"
            [routerLink]="['/rewards']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
            >{{ 'nav.rewards' | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link text-white"
            [routerLink]="['/challenges']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.challenges.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
            >{{ 'nav.challenges' | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link text-white"
            [routerLink]="['/games']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.games.screenreader' | translate : { fgbdefault: 'Move to games page' } }}"
            >{{ 'nav.games' | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link text-white"
            [routerLink]="['/benefits']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{ 'nav.benefits.screenreader' | translate : { fgbdefault: 'Move to benefits page' } }}"
            >{{ 'nav.benefits' | translate : { fgbdefault: 'Benefits' } }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link text-white"
            [routerLink]="['/rewards/wallet']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{
              'nav.redemption.history.screenreader' | translate : { fgbdefault: 'Move to redemption history page' }
            }}"
            >{{ 'nav.redemption.history' | translate : { fgbdefault: 'Redemption History' } }}</a
          >
        </li>
      </ul>
    </div>

    <!-- Right Side Content -->
    <div
      class="d-flex align-items-center flex-nowrap my-2 my-lg-0 ms-auto nav-toolbar"
      role="toolbar"
      aria-label="Account and balance toolbar"
    >
      <fgb-notification-button></fgb-notification-button>
      <div>
        <fgbcl-language-button-select [hiddenLanguagesByLcid]="['4105', '1033', '1032', '1037', '3084', '1036']" [version]="2" />
      </div>

      <!-- Menu Toggle Button -->
      <button
        class="nav-link btn d-flex align-items-center p-0 justify-content-end"
        (click)="toggleSideNav()"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="rightNavMenu"
        attr.aria-label="{{
          'nav.account.menu.screenreader'
            | translate : { fgbdefault: isNavOpen ? 'Close navigation menu' : 'Open navigation menu' }
        }}"
        focusTab
      >
        <i class="material-icons text-white menu-icon" aria-hidden="true">dehaze</i>
      </button>
    </div>
  </div>
</nav>

<!-- Loading  -->
<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4" aria-busy="true" aria-label="Loading member details">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>

<!-- Side Nav  -->
<div
  class="right-nav-menu-overlay"
  *ngIf="isNavOpen"
  [@rightMenuOverlayAnimation]
  (click)="isNavOpen = false"
  aria-hidden="true"
></div>

<!-- Side Nav Menu -->
<nav
  id="rightNavMenu"
  class="right-nav-menu bg-card-fill"
  [@rightNavAnimation]="isNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isNavOpen }"
  [attr.aria-hidden]="!isNavOpen"
  aria-label="Side navigation"
  role="navigation"
>
  <div class="d-flex flex-column">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between nav-menu-header">
      <div class="brand-logo">
        <img class="brand" [src]="'logos/logoblack.png' | contentAssetImage" draggable="false" alt="Club logo" />
      </div>
      <button type="button" class="btn-close" (click)="isNavOpen = false" aria-label="Close navigation menu"></button>
    </div>

    <!-- Member Info -->
    <div class="d-flex gap-2 rounded-0 text-black mt-3" aria-live="polite">
      <div class="member-card text-white rounded w-100">
        <div class="member-card-identity">
          <div class="card-name" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </div>
          <div class="account-num-header font-size-14" *ngIf="card$ | async as memberCard">
            {{ 'member.card.id.label' | translate : { fgbdefault: 'ID' } }} - {{ memberCard.MemberId }}
          </div>
        </div>
        <div class="w-100">
          <fgb-payment-button></fgb-payment-button>
        </div>
      </div>
    </div>

    <!-- Nav Links -->
    <ul class="right-nav-menu-list mt-3" role="menubar" aria-label="Side navigation links">
      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="material-symbols-outlined filled" aria-hidden="true">account_circle</span>{{ 'nav.account' | translate }}
          </div>
        </a>
      </li>

      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/gallery']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="material-symbols-outlined filled" aria-hidden="true">video_library</span>{{ 'nav.gallery' | translate }}
          </div>
        </a>
      </li>

      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/newsletters']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="material-symbols-outlined filled" aria-hidden="true">newsmode</span
            >{{ 'nav.newsletter' | translate : { fgbdefault: 'Newsletter' } }}
          </div>
        </a>
      </li>

      <li role="none">
        <a
          class="right-nav-menu-item text-black"
          [routerLink]="['/offers']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          role="menuitem"
          (click)="isNavOpen = false"
        >
          <div class="nav-text">
            <span class="material-symbols-outlined filled" aria-hidden="true">percent_discount</span
            >{{ 'nav.exclusive.offers' | translate : { fgbdefault: 'Exclusive Offers' } }}
          </div>
        </a>
      </li>

      <!-- Help Group -->
      <li role="none">
        <button
          class="right-nav-menu-item right-nav-menu-group text-black w-100 text-start border-0 bg-transparent"
          (click)="isHelpOpen = !isHelpOpen"
          [attr.aria-expanded]="isHelpOpen"
          aria-controls="helpSubmenu"
          attr.aria-label="{{ isHelpOpen ? 'Collapse help menu' : 'Expand help menu' }}"
          role="menuitem"
          aria-haspopup="true"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="nav-text">
              <span class="material-symbols-outlined filled" aria-hidden="true">info</span
              >{{ 'nav.help' | translate : { fgbdefault: 'Help' } }}
            </div>
            <i class="material-icons help-chevron" [class.rotated]="!isHelpOpen" aria-hidden="true">expand_more</i>
          </div>
        </button>

        <ul id="helpSubmenu" class="help-submenu list-unstyled" *ngIf="!isHelpOpen" role="menu" aria-label="Help sub-menu">
          <li role="none" class="pb-2">
            <a
              class="right-nav-menu-subitem text-black"
              [routerLink]="['/terms']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              role="menuitem"
              (click)="isNavOpen = false"
              attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
            >
              <div class="nav-text">{{ 'nav.terms' | translate }}</div>
            </a>
          </li>
          <li role="none" class="pb-2">
            <a
              class="right-nav-menu-subitem text-black"
              [routerLink]="['/faq']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              role="menuitem"
              (click)="isNavOpen = false"
              attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to FAQ page' } }}"
            >
              <div class="nav-text">{{ 'nav.faq' | translate }}</div>
            </a>
          </li>
          <li role="none" class="pb-2">
            <a
              class="right-nav-menu-subitem text-black"
              [routerLink]="['/contact']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              role="menuitem"
              (click)="isNavOpen = false"
              attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
            >
              <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <!-- Logout -->
    <button
      class="log-out font-heading bg-transparent"
      (click)="logout()"
      attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out of your account' } }}"
    >
      <i class="material-icons" aria-hidden="true">logout</i>
      <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
    </button>
  </div>
</nav>
